import type { ptBR } from './pt-BR'

/**
 * A message is either a plain string or a plural set. Both pt-BR and en have
 * exactly the `one` / `other` categories, which is why `Intl.PluralRules` is
 * enough here and a full ICU parser is not.
 */
export type Message = string | { one: string; other: string }

/** Values interpolated into `{placeholders}`. `count` also selects the plural. */
export type TranslationVars = Record<string, string | number>

/** pt-BR is the source of truth: every other locale must cover exactly its keys. */
export type TranslationKey = keyof typeof ptBR

export type Dictionary = Record<TranslationKey, Message>

export type Language = 'pt-BR' | 'en'

export const LANGUAGES: readonly Language[] = ['pt-BR', 'en'] as const

export const LANGUAGE_LABEL: Record<Language, string> = {
  'pt-BR': 'Português (BR)',
  en:      'English',
}
